import { useState } from "react";
import { X } from "lucide-react";

export function TopStrip() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="bg-brand-charcoal text-white text-[11px] sm:text-[12px] tracking-wide">
      <div className="container mx-auto pl-4 pr-10 sm:px-4 py-2 flex items-center justify-center gap-3 relative">
        <span className="text-center whitespace-nowrap truncate sm:whitespace-normal sm:truncate-none">
          <span className="sm:hidden">Dentro il Tigre — Via Kennedy 1, Campobasso</span>
          <span className="hidden sm:inline">Bottega indipendente all'interno del Tigre — Via Kennedy 1, Campobasso</span>
        </span>
        <button
          aria-label="Chiudi"
          onClick={() => setOpen(false)}
          className="absolute right-2 sm:right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
